import React from "react";
import { Col, Divider, Form, Input, Modal, Row } from "antd";
import { useClientAdd } from "hook/clients/useClient";
import { useSelector } from "react-redux";
import ClientSearch from "./component/client_search";
import ClientInput from "./component/client_input";
import ClientPermissions from "./component/client_permissions";
import ClientNote from "./component/client_note";
import ClientAction from "./component/client_action";
import ClientScan from "./component/client_scan";
import { defaultClientOpenAddSelector } from "store/user/(default)/client/default_client.selector";

//
//component
//redux
//selector
//actions
//utils
//hook
//str
const DialogAddClient = () => {
  // -------------------------- VAR -----------------------------
  const [form] = Form?.useForm();
  const { handleCloseAdd } = useClientAdd();
  // -------------------------- STATE ---------------------------
  // -------------------------- REDUX ---------------------------
  const open = useSelector(defaultClientOpenAddSelector);

  // -------------------------- FUNCTION ------------------------
  const handleClose = () => {
    handleCloseAdd(form);
  };
  // -------------------------- EFFECT --------------------------
  // -------------------------- DATA FUNCTION -------------------
  // -------------------------- RENDER --------------------------

  // -------------------------- MAIN ----------------------------
  return (
    <Modal
      open={open}
      footer={null}
      centered
      title="Thêm khách hàng mới"
      onCancel={handleClose}
      className="dialog-client-add"
      width={650}
    >
      <Divider style={{ margin: 0 }} />
      <Form form={form} layout="vertical" id="dialog-client-add">
        <Row gutter={[0, 20]} style={{ padding: 20 }}>
          <Col xl={24} lg={24} md={24} xs={24}>
            <ClientSearch />
            <ClientScan />
            <ClientInput />
          </Col>
          <Col xl={24} lg={24} md={24} xs={24}>
            <ClientPermissions />
          </Col>
          <Col xl={24} lg={24} md={24} xs={24}>
            <ClientNote />
          </Col>
          <Col xl={24} lg={24} md={24} xs={24}>
            <ClientAction />
          </Col>
        </Row>
      </Form>
    </Modal>
  );
};
export default DialogAddClient;
